/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module basic-styles/overline/overlineediting
 */

import { Plugin } from 'ckeditor5/src/core';
import AttributeCommand from '@ckeditor/ckeditor5-basic-styles/src/attributecommand';

const OVERLINE = 'overline';

/**
 * The overline editing feature.
 *
 * It registers the `'overline'` command, the <kbd>Ctrl+L</kbd> keystroke
 * and introduces the `overline` attribute in the model which renders to the view as an `<u>` element.
 *
 * @extends module:core/plugin~Plugin
 */
export default class OverlineEditing extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'OverlineEditing';
	}

	/**
	 * @inheritDoc
	 */
	init() {
		const editor = this.editor;

		// Allow strikethrough attribute on text nodes.
		editor.model.schema.extend( '$text', { allowAttributes: OVERLINE } );
		editor.model.schema.setAttributeProperties( OVERLINE, {
			isFormatting: true,
			copyOnEnter: true
		} );

		editor.conversion.attributeToElement( {
			model: OVERLINE,
			view: {
				name: 'span',
				styles: {
					'text-decoration': 'overline'
				}
			},
			upcastAlso: {
				styles: {
					'text-decoration': 'overline'
				}
			}
		} );

		// Create overline command.
		editor.commands.add( OVERLINE, new AttributeCommand( editor, OVERLINE ) );

		// Set the Ctrl+U keystroke.
		editor.keystrokes.set( 'CTRL+L', 'overline' );
	}
}
